import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { View, StyleSheet } from 'react-native';
import { SafeAreaInsetsContext } from 'react-native-safe-area-context';
import { createStackNavigator } from '@react-navigation/stack';

import Colors from '../constants/Colors';
import Languages from '../constants/Languages';
import * as Actions from '../store/Actions';
import ProfileLanding from '../components/profile/ProfileLanding';
import UserInfo from '../components/profile/UserInfo/UserInfo';
import UserSettings from '../components/profile/UserSettings';
import TopMenu from '../navigation/TopMenu';
import Plentiful from '../constants/Plentiful';
import { getToken } from '../utils/token';
import UserBenefits from '../components/profile/UserBenefits';
import HelpAndSupport from '../components/profile/HelpAndSupport';

const Stack = createStackNavigator();
class ProfileScreen extends Component {
  static propTypes = {
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  componentDidMount = async () => {
    const { navigation, actions } = this.props;
    const token = await getToken();
    if (!token) {
      navigation.navigate('Language');
    } else {
      actions.getCurrentUser();
    }

    actions.getTefapConfig();
  };

  render() {
    const { actions, registration, pantry } = this.props;
    const { language, user } = registration;
    const locale = language?.name || 'en';
    const translation = Languages.translations[locale];
    const { pantries } = pantry;

    const props = Object.assign({}, this.props, { page: 'profile' }, { translation });

    return (
      <SafeAreaInsetsContext.Consumer>
        {(insets) => (
          <View
            testID="profile"
            style={[
              styles.view,
              {
                paddingTop: insets.top,
              },
            ]}
          >
            <TopMenu {...props} />
            <Stack.Navigator
              initialRouteName="landing"
              screenOptions={{
                title: Plentiful.TITLE,
                headerShown: false,
              }}
            >
              <Stack.Screen name="landing">
                {(navProps) => {
                  const props = Object.assign(
                    {},
                    navProps,
                    { actions },
                    { translation },
                    { profile: user },
                    { locale },
                    { pantries },
                    { registration }
                  );
                  return <ProfileLanding {...props} />;
                }}
              </Stack.Screen>

              <Stack.Screen name="info">
                {(navProps) => {
                  const props = Object.assign(
                    {},
                    navProps,
                    { actions },
                    { translation },
                    { profile: user },
                    { locale },
                    { registration }
                  );
                  return <UserInfo {...props} />;
                }}
              </Stack.Screen>

              <Stack.Screen name="settings">
                {(navProps) => {
                  const props = Object.assign(
                    {},
                    navProps,
                    { actions },
                    { translation },
                    { profile: user },
                    { registration }
                  );
                  return <UserSettings {...props} />;
                }}
              </Stack.Screen>

              <Stack.Screen name="benefits">
                {(navProps) => {
                  const props = Object.assign(
                    {},
                    navProps,
                    { actions },
                    { translation },
                    { profile: user },
                    { registration }
                  );
                  return <UserBenefits {...props} />;
                }}
              </Stack.Screen>

              <Stack.Screen name="support">{HelpAndSupport}</Stack.Screen>
            </Stack.Navigator>
          </View>
        )}
      </SafeAreaInsetsContext.Consumer>
    );
  }
}

const styles = StyleSheet.create({
  view: {
    flex: 1,
    color: Colors.primaryColor,
    backgroundColor: Colors.white,
  },
});

function mapStateToProps(state) {
  return {
    registration: state.registration,
    pantry: state.pantry,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileScreen);
